import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import './TechMarquee.css';

const TechMarquee = () => {
    const marqueeRef = useRef(null);
    const animationRef = useRef(null);

    const technologies = [
        { name: 'React', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg', color: '#61DAFB' },
        { name: 'JavaScript', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg', color: '#F7DF1E' },
        
        { name: 'HTML5', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg', color: '#E34F26' },
        { name: 'CSS3', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg', color: '#1572B6' },
        { name: 'Tailwind CSS', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/tailwindcss/tailwindcss-original.svg', color: '#06B6D4' },
        { name: 'Node.js', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg', color: '#339933' },
        { name: 'Express', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/express/express-original.svg', color: '#000000' },
        { name: 'MongoDB', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg', color: '#47A248' },
        { name: 'Git', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original.svg', color: '#F05032' },
        { name: 'GitHub', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/github/github-original.svg', color: '#181717' },
        { name: 'VS Code', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vscode/vscode-original.svg', color: '#007ACC' },
        { name: 'npm', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/npm/npm-original-wordmark.svg', color: '#CB3837' },
    ];

    useEffect(() => {
        const marquee = marqueeRef.current;
        if (!marquee) return;

        const marqueeContent = marquee.querySelector('.marquee-content');
        const items = marqueeContent.children;

        // Calculate total width
        let totalWidth = 0;
        Array.from(items).forEach(item => {
            totalWidth += item.offsetWidth;
        });

        // Create infinite scroll animation
        animationRef.current = gsap.to(marqueeContent, {
            x: -totalWidth / 2,
            duration: 30,
            ease: 'none',
            repeat: -1,
        });

        // Pause on hover
        const handleMouseEnter = () => {
            if (animationRef.current) {
                animationRef.current.pause();
            }
        };

        const handleMouseLeave = () => {
            if (animationRef.current) {
                animationRef.current.resume();
            }
        };

        marquee.addEventListener('mouseenter', handleMouseEnter);
        marquee.addEventListener('mouseleave', handleMouseLeave);

        return () => {
            if (animationRef.current) {
                animationRef.current.kill();
            }
            marquee.removeEventListener('mouseenter', handleMouseEnter);
            marquee.removeEventListener('mouseleave', handleMouseLeave);
        };
    }, []);

    return (
        <div className="tech-marquee-section">
            <div className="tech-marquee-container">
                <h2 className="tech-marquee-title">Technologies I Work With</h2>
                <div className="tech-marquee" ref={marqueeRef}>
                    <div className="marquee-content">
                        {/* Render technologies twice for seamless loop */}
                        {[...technologies, ...technologies].map((tech, index) => (
                            <div
                                key={index}
                                className="tech-item"
                                style={{ '--tech-color': tech.color }}
                            >
                                <div className="tech-icon-wrapper">
                                    <img
                                        src={tech.icon}
                                        alt={tech.name}
                                        className="tech-icon"
                                    />
                                </div>
                                <span className="tech-name">{tech.name}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TechMarquee;
